import { render, staticRenderFns } from "./HeadMenu.vue?vue&type=template&id=95a215a0&"
import script from "./HeadMenu.vue?vue&type=script&lang=js&"
export * from "./HeadMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports